module.exports = __webpack_public_path__ + "static/media/student-summary-win20.efa35080.png";